
  /**
   * Fabric Hover Popup & Mobile Toggle — Global Event Delegation
   * Uses document-level delegation so it works after variant switches (innerHTML replacement)
   * Shows per-color popup on hover of ANY swatch (not just the active/selected one)
   */
  (function () {
    /* Guard against duplicate initialization */
    if (window.__fabricPopupInitialized) return;
    window.__fabricPopupInitialized = true;

    var hideTimeout = null;
    var activePopup = null;

    function getAllPerColorPopups() {
      return document.querySelectorAll('.fabric-hover-popup--per-color');
    }

    function getFallbackPopup() {
      return document.getElementById('fabric-hover-popup');
    }

    function getPopupForColor(colorValue) {
      if (!colorValue) return getFallbackPopup();
      var popup = document.querySelector('.fabric-hover-popup--per-color[data-color-value="' + colorValue + '"]');
      return popup || getFallbackPopup();
    }
    function getPopupForLabel(label) {
      var colorValue = label.getAttribute('data-color-value');
      /* Inside the product-group picker, only show a popup when an exact per-color
         popup exists for this colour. Never fall back to #fabric-hover-popup, so a
         colour with no matching sibling (unavailable combination) shows nothing. */
      if (label.closest('.product-group-picker')) {
        if (!colorValue) return null;
        return document.querySelector('.fabric-hover-popup--per-color[data-color-value="' + colorValue + '"]');
      }
      return getPopupForColor(colorValue);
    }



    function hideAllPopups() {
      var popups = getAllPerColorPopups();
      popups.forEach(function (p) {
        p.classList.remove('is-visible');
        p.setAttribute('aria-hidden', 'true');
        p.style.top = '';
        p.style.bottom = '';
        p.style.width = '';
      });
      var fallback = getFallbackPopup();
      if (fallback) {
        fallback.classList.remove('is-visible');
        fallback.setAttribute('aria-hidden', 'true');
        fallback.style.top = '';
        fallback.style.bottom = '';
        fallback.style.width = '';
      }
      activePopup = null;
    }

    function showPopup(popup) {
      if (!popup) return;
      clearTimeout(hideTimeout);
      /* Hide any other visible popup first */
      hideAllPopups();
      /* Reset any previously applied inline positioning */
      popup.style.top = '';
      popup.style.bottom = '';
      popup.style.width = '';
      popup.classList.add('is-visible');
      popup.setAttribute('aria-hidden', 'false');
      activePopup = popup;
      /* Adjust vertical position so popup stays within the viewport */
      repositionPopup(popup);
    }

    function repositionPopup(popup) {
      if (!popup) return;
      var rect = popup.getBoundingClientRect();
      var viewportHeight = window.innerHeight;
      var viewportWidth = window.innerWidth;
      var margin = 16; /* breathing room from viewport edges */

      /* If the popup bottom is cut off below the viewport */
      if (rect.bottom > viewportHeight - margin) {
        var overflow = rect.bottom - (viewportHeight - margin);
        /* Shift upward by setting a new top value */
        var currentTop = parseInt(window.getComputedStyle(popup).top, 10) || -40;
        popup.style.top = currentTop - overflow + 'px';
      }
      /* If the popup top is above the viewport (shifted too high) */
      var rectAfter = popup.getBoundingClientRect();
      if (rectAfter.top < margin) {
        popup.style.top = '';
        popup.style.bottom = 'auto';
        /* Position from the top of the parent, ensuring it's within viewport */
        var parentRect = popup.parentElement.getBoundingClientRect();
        var desiredTop = margin - parentRect.top;
        popup.style.top = desiredTop + 'px';
      }

      /* If the popup extends past the left edge of the viewport */
      var rectFinal = popup.getBoundingClientRect();
      if (rectFinal.left < margin) {
        /* Reduce width to fit within viewport */
        var availableWidth = rectFinal.right - margin;
        popup.style.width = availableWidth + 'px';
      }
    }

    function hidePopup() {
      hideTimeout = setTimeout(function () {
        if (!activePopup) return;
        /* Don't hide if mouse is currently over the popup */
        if (activePopup.matches(':hover')) return;
        activePopup.classList.remove('is-visible');
        activePopup.setAttribute('aria-hidden', 'true');
        activePopup.style.top = '';
        activePopup.style.bottom = '';
        activePopup.style.width = '';
        activePopup = null;
      }, 500);
    }

    /* === Material Switcher (multi-material standalone) === */
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.material-switcher-btn');
      if (!btn) return;

      var wrapper = btn.closest('#product-materials-data') || btn.closest('.fabric-standalone-card');
      if (!wrapper) return;

      var targetId = btn.getAttribute('data-material-target');
      if (!targetId) return;

      wrapper.querySelectorAll('.material-switcher-btn').forEach(function (item) {
        item.classList.remove('active');
      });
      wrapper.querySelectorAll('.material-panel').forEach(function (panel) {
        panel.classList.remove('active');
      });

      btn.classList.add('active');

      var targetPanel = document.getElementById(targetId);
      if (targetPanel) {
        targetPanel.classList.add('active');
      }
    });

    /* === DESKTOP: Hover on ANY color swatch shows the matching popup === */
    document.addEventListener('mouseenter', function (e) {
      if(!e.target || typeof e.target.closest !== 'function') return;
      var label = e.target.closest('label.color-swatch-label');
      if (!label) return;
      /* Get the color value from the data attribute */
      var colorValue = label.getAttribute('data-color-value');
      // var popup = getPopupForColor(colorValue);
      // if(popup) {
      //   showPopup(popup);
      // }
      var popup = getPopupForLabel(label);
      if(popup) {
        showPopup(popup);
      }
    }, true);

    /* On swatch click, hide popup briefly (variant will re-render) */
    document.addEventListener('click', function (e) {
      var label = e.target.closest('label.color-swatch-label');
      if (!label) return;
      clearTimeout(hideTimeout);
      hideAllPopups();
    });

    /* After variant switch completes (section re-rendered), show popup if mouse is still on a swatch */
    window.addEventListener('gallery-recreated', function () {
      setTimeout(function () {
        var hoveredLabel = document.querySelector('label.color-swatch-label:hover');
        if(hoveredLabel) {
          var colorValue = hoveredLabel.getAttribute('data-color-value');
          // var popup = getPopupForColor(colorValue);
          // if (popup) {
          //   showPopup(popup);
          // }
          var popup = getPopupForLabel(hoveredLabel);
          if (popup) {
            showPopup(popup);
          }
        }
      }, 100);
    });

    document.addEventListener('mouseleave', function (e) {
      if(!e.target || typeof e.target.closest !== 'function') return;
      var label = e.target.closest('label.color-swatch-label');
      if(label) {
        hidePopup();
      }
      /* Also handle leaving the popup itself */
      var popup = e.target.closest('.fabric-hover-popup');
      if (popup) {
        hidePopup();
      }
    }, true);

    document.addEventListener('mouseenter', function (e) {
      if(!e.target || typeof e.target.closest !== 'function') return;
      var popup = e.target.closest('.fabric-hover-popup');
      if (popup && popup.classList.contains('is-visible')) {
        clearTimeout(hideTimeout);
      }
    }, true);

    /* === MOBILE: Toggle fabric details === */
    document.addEventListener('click', function (e) {
      try {
        if (!e.target || !e.target.closest) return;
        /* Toggle button */
        var toggle = e.target.closest('#fabric-mobile-toggle');
        if (toggle) {
          var content = document.getElementById('fabric-mobile-content');
          if (!content) return;
          var isExpanded = content.classList.contains('is-expanded');
          var colorBox = toggle.closest('.color-collapsible-box');
          if (isExpanded) {
            content.classList.remove('is-expanded');
            content.setAttribute('aria-hidden', 'true');
            toggle.setAttribute('aria-expanded', 'false');
            toggle.classList.remove('is-hidden');
            if (colorBox) colorBox.classList.remove('fabric-details-expanded');
          } else {
            content.classList.add('is-expanded');
            content.setAttribute('aria-hidden', 'false');
            toggle.setAttribute('aria-expanded', 'true');
            toggle.classList.add('is-hidden');
            if (colorBox) colorBox.classList.add('fabric-details-expanded');
          }
          return;
        }

        /* Close button */
        var closeBtn = e.target.closest('#fabric-mobile-close');
        if (closeBtn) {
          var content = document.getElementById('fabric-mobile-content');
          var toggle = document.getElementById('fabric-mobile-toggle');
          var colorBox = closeBtn.closest('.color-collapsible-box');
          if (content) {
            content.classList.remove('is-expanded');
            content.setAttribute('aria-hidden', 'true');
          }
          if (toggle) {
            toggle.setAttribute('aria-expanded', 'false');
            toggle.classList.remove('is-hidden');
          }
          if (colorBox) colorBox.classList.remove('fabric-details-expanded');
        }
      }
      catch (err) {
        console.warn('[metafield_material] mobile toggle click error:', err);
      }
    });
  })();